"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeCustomerResultWithPhoneBookToJSON = exports.ChangeCustomerResultWithPhoneBookFromJSONTyped = exports.ChangeCustomerResultWithPhoneBookFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ChangeCustomerResultWithPhoneBookFromJSON(json) {
    return ChangeCustomerResultWithPhoneBookFromJSONTyped(json, false);
}
exports.ChangeCustomerResultWithPhoneBookFromJSON = ChangeCustomerResultWithPhoneBookFromJSON;
function ChangeCustomerResultWithPhoneBookFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customer': !(0, runtime_1.exists)(json, 'customer') ? undefined : (0, _1.CustomerDataFromJSON)(json['customer']),
        'phoneBook': !(0, runtime_1.exists)(json, 'phoneBook') ? undefined : (json['phoneBook'].map(_1.PhoneNumberWithTypeFromJSON)),
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (0, _1.MessagesFromJSON)(json['errors']),
        'warnings': !(0, runtime_1.exists)(json, 'warnings') ? undefined : (0, _1.MessagesFromJSON)(json['warnings']),
    };
}
exports.ChangeCustomerResultWithPhoneBookFromJSONTyped = ChangeCustomerResultWithPhoneBookFromJSONTyped;
function ChangeCustomerResultWithPhoneBookToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customer': (0, _1.CustomerDataToJSON)(value.customer),
        'phoneBook': value.phoneBook === undefined ? undefined : (value.phoneBook.map(_1.PhoneNumberWithTypeToJSON)),
        'errors': (0, _1.MessagesToJSON)(value.errors),
        'warnings': (0, _1.MessagesToJSON)(value.warnings),
    };
}
exports.ChangeCustomerResultWithPhoneBookToJSON = ChangeCustomerResultWithPhoneBookToJSON;
//# sourceMappingURL=ChangeCustomerResultWithPhoneBook.js.map